// src/pages/materials/MaterialsUserTemplateNew.jsx
import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// 공용 에디터(사용자 템플릿)
// import UserForm from "../../components/common/form/UserForm"; // PC용
import MobileUserForm from "./MobileUserForm"; // Mobile용

const FORM_TYPES = [
  { value: "PS", label: "수급계획" },
  { value: "PO", label: "발주서" },
  { value: "GR", label: "입고서" },
  { value: "GI", label: "출고서" },
  { value: "QC", label: "검수 요청" },
  { value: "CK", label: "검수 확인" },
];

export default function MaterialsUserTemplateNew() {
  const nav = useNavigate();
  const { id: projectId } = useParams();

  const [formType, setFormType] = useState("PS");

  const params = useMemo(
    () => ({
      module: "material",
      formType, // 반드시 대문자
      scope: "project",
      project: projectId,
    }),
    [formType, projectId]
  );

  return (
    <div
      className="mobile-page-root mb-16"
      style={{ width: '100%', maxWidth: '100vw', minWidth: 0, display: 'flex', justifyContent: 'center', overflowX: 'hidden', boxSizing: 'border-box' }}
    >
      <div
        className="mobile-page-root-inner space-y-3"
        style={{ width: '100%', maxWidth: '480px', margin: '0 auto', padding: '0 1rem 1rem', boxSizing: 'border-box', overflowX: 'hidden' }}
      >
        {/* 헤더 */}
        <div className="bg-white rounded-lg p-4 border min-w-0">
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0 flex-1">
              <h2 className="text-lg font-bold text-gray-900 truncate">
                사용자 템플릿 문서 작성
              </h2>
              <p className="text-gray-500 text-xs mt-0.5">
                프로젝트 공용 사용자 템플릿을 불러와 편집 후 저장합니다.
              </p>
            </div>
            <button
              className="btn-basic-sm flex-shrink-0"
              onClick={() => nav(-1)}
            >
              뒤로
            </button>
          </div>
        </div>

        {/* 문서 종류 선택 */}
        <div className="bg-white rounded-lg border p-4">
          <div className="mb-2 text-xs font-medium text-gray-700">문서 종류</div>
          <select
            className="w-full border rounded-lg px-3 py-2 text-sm"
            value={formType}
            onChange={(e) => setFormType(e.target.value.toUpperCase())}
          >
            {FORM_TYPES.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        {/* 사용자 에디터 (모바일 전용) */}
        <div className="min-w-0">
          <MobileUserForm
            key={`${projectId}-${formType}`}
            mode={2}
            module="material"
            formType={formType}
            scope="project"
            project={projectId}
          />
        </div>
      </div>
    </div>
  );
}
